module.exports = __webpack_public_path__ + "img/logowhite.64ea3451.svg";